var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrowIconOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "rotate(-90 15 15)",
    fill: "#F5F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9665 21.3126C15.0267 21.2882 15.0831 21.2516 15.1319 21.2028C15.1319 21.2028 15.1319 21.2028 15.1319 21.2028L16.6471 19.6876L22.2029 14.1317C22.3982 13.9365 22.3982 13.6199 22.2029 13.4246L20.6877 11.9094C20.4924 11.7141 20.1759 11.7141 19.9806 11.9094L14.7783 17.1117L9.57603 11.9094C9.38077 11.7141 9.06419 11.7141 8.86893 11.9094L7.3537 13.4246C7.15844 13.6199 7.15844 13.9365 7.3537 14.1317L12.9095 19.6876L14.4248 21.2028C14.4934 21.2714 14.5771 21.316 14.6652 21.3363C14.765 21.3594 14.8706 21.3515 14.9665 21.3126Z",
    fill: "#593F16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowIconOpen);
export default __webpack_public_path__ + "static/media/select-arrow-icon-open.43cab6a6736747c81d3e2548094aaa63.svg";
export { ForwardRef as ReactComponent };